import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  CreditCard, ShoppingCart, Users, Building2, FileText, Database,
  LayoutGrid, MessageSquare, Zap, Code, Globe, Table,
  CheckCircle2, Circle, ArrowRight,
} from "lucide-react";

const ICON_MAP = {
  CreditCard, ShoppingCart, Users, Building2, FileText, Database,
  LayoutGrid, MessageSquare, Zap, Code, Globe, Table,
};

const CATEGORY_LABELS = {
  payments: "Payments",
  crm: "CRM",
  productivity: "Productivity",
  communication: "Communication",
  development: "Development",
  content: "Content",
};

export default function IntegrationCard({ integration, onConnect, onDisconnect }) {
  const { t } = useTranslation();
  const isConnected = integration.status === "connected";
  const IconComponent = ICON_MAP[integration.icon] || Circle;
  const brandColor = integration.brandColor || "#f59e0b";

  return (
    <div
      className="group relative border border-zinc-800 rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 hover:border-zinc-700"
      style={{ background: "rgba(255,255,255,0.02)" }}
    >
      {/* Brand color accent line */}
      <div
        className="absolute top-0 left-6 right-6 h-[2px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
        style={{ backgroundColor: brandColor }}
      />

      <div className="flex items-start justify-between mb-4">
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0"
          style={{ backgroundColor: `${brandColor}15`, border: `1px solid ${brandColor}30` }}
        >
          <IconComponent className="w-6 h-6" style={{ color: brandColor }} />
        </div>
        {isConnected ? (
          <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-amber-500 border border-amber-500/30 px-2.5 py-1">
            <CheckCircle2 className="w-3 h-3" /> Connected
          </span>
        ) : (
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 border border-zinc-800 px-2.5 py-1">{t('integration_card.available')}</span>
        )}
      </div>

      <h3 className="text-lg font-display font-bold text-white mb-1">
        {integration.name}
      </h3>
      <p className="text-xs text-zinc-500 font-mono uppercase tracking-wider mb-3">
        {CATEGORY_LABELS[integration.category]}
      </p>
      <p className="text-sm text-zinc-400 leading-relaxed mb-5">
        {integration.tagline}
      </p>

      <div className="flex items-center gap-3">
        <Link
          to={`/marketplace/integrations/${integration.id}`}
          className="flex-1 text-center border border-zinc-800 hover:border-amber-500/50 text-zinc-300 hover:text-amber-500 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors"
        >
          Details
        </Link>
        {isConnected ? (
          <button
            onClick={() => onDisconnect && onDisconnect(integration.id)}
            className="flex-1 border border-red-500/20 hover:border-red-500 text-red-400 hover:text-red-300 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors"
          >
            Disconnect
          </button>
        ) : (
          <button
            onClick={() => onConnect && onConnect(integration.id)}
            className="flex-1 bg-amber-500 hover:bg-amber-400 text-black px-4 py-2.5 font-bold uppercase tracking-wider text-[10px] transition-colors"
          >
            Connect
          </button>
        )}
      </div>
    </div>
  );
}
